<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14WWjhG/tc-custom/9783985310166.jpg?1703042201173" alt="This image is the cover for the book The Frontier, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Frontier, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>The Frontier is a classic war story and is that old idea of the conflict between the old and the new, between fathers and sons, and between the intense convictions of yesterday and tomorrow.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maurice Leblanc
      </h2>
      
      <p class="authorDescription body article">Maurice Marie Émile Leblanc; 11 December 1864[2] – 6 November 1941) was a French novelist and writer of short stories, known primarily as the creator of the fictional gentleman thief and detective Arsène Lupin, often described as a French counterpart to Arthur Conan Doyle's creation Sherlock Holmes.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?640b7f4e